import { SessionState, VideoPlatform } from "app-constants/constants"
import useConventionSessionRealTimeCapacity from "hooks/sessions/useConventionSessionRealTimeCapacity"
import useJoinSession from "hooks/sessions/useJoinSession"
import useRelativeTime from "hooks/useRelativeTime"
import ConventionSession from "models/convention-api/v1/ConventionSession"
import moment from "moment-timezone"

interface SessionStateProps {
  session: ConventionSession
  realTimeCapacity: ReturnType<typeof useConventionSessionRealTimeCapacity>
  joinSession: ReturnType<typeof useJoinSession>
}

const useSessionState = (props: SessionStateProps): SessionState | null => {
  const { joinSession, session, realTimeCapacity } = props

  const relativeTime = useRelativeTime({
    startAt: moment(session.start_at).subtract(5, "minutes"), // 5 minutes before start time
    endAt: moment(session.end_at),
  })

  const isEnded = relativeTime.after
  const isZoom = session.video_platform === VideoPlatform.ZOOM
  const readyToJoin = relativeTime.during || relativeTime.after

  if (isEnded && realTimeCapacity?.empty) return SessionState.ENDED
  if (realTimeCapacity?.full) return SessionState.AT_CAPACITY
  if (joinSession.isJoined) return SessionState.JOINED
  if (readyToJoin) return SessionState.READY_TO_JOIN
  if (isZoom) return SessionState.ZOOM

  return null
}

export default useSessionState
